module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blank"
  }, [_c('group', {
    attrs: {
      "gutter": "8"
    }
  }, [_c('cell', {
    attrs: {
      "title": "II类户开户代扣协议"
    },
    on: {
      "click": function($event) {
        return _vm.nextRoute('persh')
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/images/link.png"),
      "height": "12",
      "width": "7",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "个人信息使用授权"
    },
    on: {
      "click": function($event) {
        return _vm.nextRoute('perauthorize')
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/images/link.png"),
      "height": "12",
      "width": "7",
      "alt": ""
    }
  })])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0988afa2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/protocollist.vue
// module id = 187
// module chunks = 0